var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{ 
        "app--supports-hairlines": _vm.supportsHairlines,
        "app--chrome": _vm.isChrome
    },attrs:{"data-scroll-direction":_vm.scrollDir}},[_c('AppHeader'),_vm._v(" "),_c('AppLogo'),_vm._v(" "),_c('AppMain'),_vm._v(" "),_c('AppFooter'),_vm._v(" "),_c('GdprBar'),_vm._v(" "),(_vm.isDevGridVisible)?_c('DevGrid'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }